import React from "react";
import ContactHero from "../components/Contact/hero";
import ContactSection from "../components/Contact/contact-section";

export default function Contact() {
  return (
    <main>
      <div className="pt-20">
        <ContactHero />
        <ContactSection />
      </div>
    </main>
  );
}
